import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Arrival: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.38 43.61">
            <g>
                <g>
                    <path fill={color} d="M0,9.75V0h6.67v1.84H2.04v2.4h4.21v1.84H2.04v3.68H0Z"/>
                    <path fill={color} d="M8.2,9.75V0h2.04v9.75h-2.04Z"/>
                    <path fill={color} d="M12.5,9.75V0h2.21l3.87,6.4V0h2.04v9.75h-2.21l-3.87-6.4v6.4h-2.04Z"/>
                    <path fill={color} d="M22.87,9.75V0h2.04v9.75h-2.04Z"/>
                    <path fill={color} d="M26.75,9.02v-1.1h4.38c.28,0,.42-.14.42-.42v-1.02c0-.27-.12-.43-.35-.47l-2.76-.57c-1.13-.23-1.7-.98-1.7-2.28v-.79c0-1.58.79-2.37,2.37-2.37h3.24l.95.73v1.1h-4.1c-.28,0-.42.14-.42.42v.92c0,.26.12.42.35.47l2.76.55c1.13.23,1.7.98,1.7,2.28v.9c0,1.58-.79,2.37-2.37,2.37h-3.52l-.95-.74Z"/>
                    <path fill={color} d="M35.43,9.75V0h2.04v3.82h3.62V0h2.04v9.75h-2.04v-4.1h-3.62v4.1h-2.04Z"/>
                </g>
                <path fill={color} d="M.24,13.6v28.08l7.88-14.78v14.86H2.31l-.99,1.86h8.66v-20.17h23.65v20.17h9.74V13.6H.24ZM8.12,21.58v2.67l-6.01,11.27V15.46h11.14l-1.03,1.93-.36-.14-.03.06-2.28,4.27h-1.43ZM10.95,21.58l2.04-3.82.36.14.03-.06,1.27-2.39h1.67l-1.56,2.92-.36-.14-.03.06-1.75,3.28h-1.67ZM14.03,21.58l1.51-2.83.36.14.03-.06,1.8-3.38h1.67l-2.09,3.91-.36-.14-.03.06-1.22,2.29h-1.67ZM41.51,41.75h-6.01v-20.17h-18.39l.98-1.83.36.14.03-.06,2.33-4.37h20.71v26.29Z"/>
            </g>
        </svg>
    );
};

export default Arrival;
